import config from '../../../config';

export function expandElement(elementId, elementWrap, callback) {
    const $element = document.querySelector(elementId);

    if ($element) {
        const $body = document.querySelector('body');
        const $buttonToggle = $element.querySelector('.button-toggle-expand');

        if ($buttonToggle) {
            const $icon = $buttonToggle.querySelector('i');

            if ($icon) {
                $icon.classList.remove('icon-maximize-2');
                $icon.classList.add('icon-x');
            }

            const $button = $buttonToggle.cloneNode(true);

            $button.onclick = function() {
                retractElement(elementId, elementWrap, callback);
            }

            $buttonToggle.parentNode.replaceChild($button, $buttonToggle);
        }

        if ($body) {
            if (config.mode === 'development') {
                $element.classList.add('expanded-element-development');
            }

            if (callback) {
                callback(true);
            }

            $element.classList.add('expanded-element');
            $body.append($element);
        }
    }
}

export function retractElement(elementId, elementWrap, callback) {
    const $elementWrap = document.querySelector(elementWrap || '.content-wrap');

    if ($elementWrap) {
        const $element = document.querySelector('.expanded-element');

        if ($element) {
            const $buttonToggle = $element.querySelector('.button-toggle-expand');

            if ($buttonToggle) {
                const $icon = $buttonToggle.querySelector('i');

                if ($icon) {
                    $icon.classList.remove('icon-x');
                    $icon.classList.add('icon-maximize-2');
                }

                const $button = $buttonToggle.cloneNode(true);

                $button.onclick = function() {
                    expandElement(elementId, elementWrap, callback);
                }
                $buttonToggle.parentNode.replaceChild($button, $buttonToggle);
            }

            if (callback) {
                callback(false);
            }

            $element.classList.remove('expanded-element');
            $elementWrap.append($element);
        }
    }
}
